import error from "core/resources/firebase/error";
import { showError, showErrorAxios } from "infra/helpers/alerta";
import { QueryClient, QueryClientProvider, useQueryClient } from "react-query";
import { useCallback } from "react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      refetchOnMount: "always",
      cacheTime: 0,
      onError(err: any) {
        if (err.response) {
          if (err.response?.status !== 401) {
            showErrorAxios(err);
          }
        } else {
          showError(error[(err as any).code]);
        }
      },
    },
    mutations: {
      onError(err: any) {
        showErrorAxios(err);
      },
    },
  },
});

export const ReactQueryProvider: any = ({ children }: any) => (
  <QueryClientProvider client={queryClient as any}>
    {children}
  </QueryClientProvider>
);

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  const doInvalidateQueryWithStringKey = useCallback(
    (key: string) => {
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) => {
          return typeof queryKey === "string"
            ? queryKey.startsWith(key)
            : false;
        },
      });
    },
    [queryClient]
  );

  return {
    doInvalidateQueryWithStringKey,
  };
};
